// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#MapCompare {
    touch-action: none;
    position: absolute;
    background-color: var(--map-button-bg-color);
    width: 0.25em;
    margin-left: -0.125em;
    top: 0;
    bottom: 0;
    cursor: ew-resize;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

#MapCompare div.map-compare-handle {
    height: 3em;
    width: 3em;
    margin-left: -1.375em;
    background-color: var(--map-button-bg-color);
    display: flex;
    align-items: center;
    border-radius: 1.5em;
}

#MapCompare span.map-compare-handle-icon {
    flex: 0 0 1.5em;
    color: var(--map-button-text-color);
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./qwc2/plugins/style/MapCompare.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,4CAA4C;IAC5C,aAAa;IACb,qBAAqB;IACrB,MAAM;IACN,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,4CAA4C;IAC5C,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,mCAAmC;IACnC,kBAAkB;AACtB","sourcesContent":["#MapCompare {\n    touch-action: none;\n    position: absolute;\n    background-color: var(--map-button-bg-color);\n    width: 0.25em;\n    margin-left: -0.125em;\n    top: 0;\n    bottom: 0;\n    cursor: ew-resize;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n#MapCompare div.map-compare-handle {\n    height: 3em;\n    width: 3em;\n    margin-left: -1.375em;\n    background-color: var(--map-button-bg-color);\n    display: flex;\n    align-items: center;\n    border-radius: 1.5em;\n}\n\n#MapCompare span.map-compare-handle-icon {\n    flex: 0 0 1.5em;\n    color: var(--map-button-text-color);\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
